<template>
  <div class="empty flex-v">
    <img class="img" src="~images/空值@2x.png" alt="">
    <span class="title" v-if="title">{{title}}</span>
    <span class="tips" v-if="tips">{{tips}}</span>
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: "Empty",
  data() {
    return {};
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    tips: {
      type: String,
      default: ''
    }
  },
  methods: {},
};
</script>
<style lang="less">
.empty{
  height: 100%;
  justify-content: center;
  align-items: center;

  .img{
    width: 160px;
    height: 160px;
  }

  .title{
    color: #666666;
    font-size: 16px;
    margin-top: 10px;
  }

  .tips{
    color: #999999;
    font-size: 12px;
    margin-top: 5px;
  }
}
</style>